import {
  optionalI18nString,
  optionalImage
} from '@/services/dataStore/queries/fragments'

export const layerPacksQuery = () =>
  `*[_type == "layerPack"] {
    _id,
    ${optionalI18nString('description')},
    ${optionalImage('mapScreenshot')},
    'effect': effect._ref,
    'dataLayers': dataLayers[]._ref
  }`
